import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const STORAGE_KEY = "webfix_cookie_consent";
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const pathname = useLocation().pathname;
  useEffect(() => {
    const consent = window.localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, [pathname]);
  const handleConsent = (value) => {
    window.localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };
  if (!visible) {
    return null;
  }
  return <div className="fixed bottom-4 left-4 right-4 z-[60] rounded-2xl border border-[#D4AF37]/40 bg-white p-4 shadow-[0_20px_50px_rgba(17,43,30,0.14)] backdrop-blur-sm sm:bottom-6 sm:left-6 sm:right-6 sm:p-5 lg:left-auto lg:right-8 lg:max-w-xl">
      <p className="text-sm leading-relaxed text-[#1A1A1A] sm:text-base">
        Hiru Ayurveda Resorts verwendet Cookies, um die Sicherheit der Website zu verbessern, die Leistung zu optimieren und ein angenehmeres Erlebnis zu bieten. Weitere Informationen finden Sie in unserer
        <Link to="/contact-us" className="font-semibold text-[#244B0C] underline-offset-2 transition-colors hover:text-[#D4AF37]">
          Datenschutzerklärung
        </Link>
        .
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button
    type="button"
    onClick={() => handleConsent("declined")}
    className="rounded-full border border-[#D4AF37]/60 bg-[#F9F6F0] px-4 py-2 text-sm font-semibold text-[#1A1A1A] transition-colors duration-200 hover:border-[#244B0C] hover:text-[#244B0C]"
  >
          Ablehnen
        </button>
        <button
    type="button"
    onClick={() => handleConsent("accepted")}
    className="rounded-full bg-gradient-to-r from-[#D4AF37] via-[#C89A2A] to-[#244B0C] px-4 py-2 text-sm font-semibold text-white shadow-md transition-opacity duration-200 hover:opacity-90"
  >
          Zustimmen
        </button>
      </div>
    </div>;
};
export default CookieConsent;
